import React, { useEffect, useState } from "react";
import TopRightActionLinks from "../../TopRightActionLinks";
import { useParams } from "react-router-dom";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import AIChat from "../../../Chat/AiChat";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import InfoTooltipIcon from "../../../../HtmlElements/InfoTooltipIcon";

function FutureBets({ futureBets = {} }) {
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  // helper to detect if a field is an object that can be used as tooltip payload
  const betHasTooltipPayload = (field) =>
    field != null && typeof field === "object" && field.headline != null;

  const bets = Object.values(futureBets);

  // console.log("FUTURE BETS: " + JSON.stringify(bets));

  return (
    <>
      <div className="future_bets_wrapper mb-2">
        <div className="future_bets_headblock">
          <div className="future_bets_subheadblock">
            <h5 className="future_bets_head">
              Future Bets & Leadership-Led Initiatives
            </h5>
          </div>
          <div className="future_bets_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="row">
          {bets.map((bet, index) => (
            <div className="col-md-6">
              <div className="future_bets_subblock">
                <div className="d-inline-block">
                  <h5 className="future_bets_head d-inline-block">
                    {bet?.headline || ""}
                  </h5>
                  {betHasTooltipPayload(bet) && (
                    <div className="d-inline-block">
                      <InfoTooltipIcon payload={bet} />
                    </div>
                  )}
                </div>
                <p className="future_bets_para">
                  {/* {bet?.description || ""} */}
                  {formatBoldText(
                    bet?.description ? (
                      <ParsedTextWithLinks text={bet?.description} />
                    ) : (
                      ""
                    )
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </>
  );
}

export default FutureBets;
